var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen_box",attrs:{"title":"全屏/正常"}},[_c('img',{attrs:{"src":"/icon/full.png"},on:{"click":_vm.handleFullScreen}})])}
var staticRenderFns = []

export { render, staticRenderFns }